// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2679":"d04a9ee238a3b061","5887":"61d1d89a2793668a","7121":"9857d7a6e3f6ab53"}[chunkId] + ".css";
};